import React, { Component } from 'react'
import GoTrue from "gotrue-js"
import { connect } from 'react-redux'
import Footer from '../components/Footer'
import Header from '../components/Header'


const auth = new GoTrue({
  APIUrl: "https://www.englishforlibya.com/.netlify/identity",
  audience: "",
  setCookie: true
});




class PasswordUpdate extends Component { 

  
  state = {
    password: '',
  }

  passwordInput = (event) => {
    this.setState({password: event.target.value})
  }
  
  updatePassword = (event) => {

    event.preventDefault()

    const user = auth.currentUser();    

    user
      .update({ password: this.state.password })
      .then(response => console.log('User has been updated'))
      .catch(error => {
        console.log("Failed to update user: %o", error);
      });

    
  }



  
  
  render() {

    return (

        <div>

          <Header />

          <p>{this.props.user.email} please provide a new password.</p>

          <h2 style={{marginTop: 20, color: '#816992'}}>Set new password</h2>
          <form onSubmit={this.updatePassword}>
                
            <label>New password</label>
              <input placeholder="New password" type="text" value={this.state.password} onChange={this.passwordInput}></input>
            <br/>
                
            <input style={{marginTop: 20}} className="purple-button" type="submit" value="Submit" />
          
          </form>

          <Footer />

        </div>

    )
  }

}

const mapStateToProps = (state) => {
  return {
      user: state.user
  };
};

export default connect(mapStateToProps)(PasswordUpdate)



// WEBPACK FOOTER //
// ./src/components/PasswordUpdate.js